import CityPageTemplate from "../city-template/CityPageTemplate";
import { concordNcConfig } from "./data";

export default function ConcordNcPage() {
  return <CityPageTemplate config={concordNcConfig} />;
}